<script setup lang="ts">
  import { Card, CardContent, CardFooter } from "@/components/ui/card";
  import { Button } from "@/components/ui/button";
  import { Plus } from "lucide-vue-next";

  withDefaults(
    defineProps<{
      elementName: string;
      addElement?: () => void;
      showHeader?: boolean;
    }>(),
    {
      addElement: undefined,
      showHeader: true,
    },
  );
</script>

<template>
  <Card class="flex max-h-[calc(100vh-60px-40px)] flex-col gap-0 overflow-hidden py-0">
    <div
      v-if="showHeader && $slots['header-action']"
      class="flex items-center justify-between gap-2 px-3 pt-3">
      <slot name="header-action" />
    </div>
    <CardContent class="min-h-0 flex-1 space-y-0.5 overflow-y-auto p-2">
      <slot name="elements" />
    </CardContent>
    <CardFooter
      v-if="addElement || $slots.footer"
      class="flex flex-col gap-2 border-t px-3 py-2.5">
      <Button
        v-if="addElement"
        variant="outline"
        class="w-full shadow-xs"
        @click="addElement">
        <Plus />
        Add {{ elementName }}
      </Button>
      <slot name="footer" />
    </CardFooter>
  </Card>
</template>
